import { Component, Input, OnInit } from '@angular/core';

import {
  injectComponentTelemetryService,
  EnableComponentTelemetry,
  EnableClassTelemetry,
} from 'app/services/otel.service';

@EnableClassTelemetry()
@Component({
  selector: 'app-lex-button',
  templateUrl: './lex-button.component.html',
  styleUrls: ['./lex-button.component.scss'],
  standalone: false,
})
export class LexButtonComponent implements OnInit {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();
  @Input() color: 'red' | 'green' | 'blue' | 'white' = 'blue';
  @Input() size: 'big' | 'normal' | 'medium' | 'small' = 'normal';
  @Input() loading: boolean;
  @Input() buttonClass = '';
  @Input() disabled: boolean;

  readonly spinnerDimensions = {
    big: {
      size: 35,
      width: 4,
    },
    normal: {
      size: 25,
      width: 3,
    },
    small: {
      size: 15,
      width: 2,
    },
  };

  constructor() {}

  ngOnInit() {}
}
